// Location names mapping
export const LOCATION_NAMES = {
    zcs: "Zacatecas",
    ags: "Aguascalientes",
    ags_south: "Aguascalientes Sur",
    leon: "León"
};

// Stock status formatting
export const formatStockStatus = (stockData) => {
    if (!stockData) return { hasStock: false, locations: [], message: "Sin stock" };

    const locations = [];
    let hasStock = false;

    try {
        // Check each location
        Object.entries(stockData).forEach(([locationCode, status]) => {
            if (locationCode !== 'stock' && locationCode !== 'detail' && typeof status === 'string') {
                if (status === "En Stock") {
                    locations.push(LOCATION_NAMES[locationCode] || locationCode);
                    hasStock = true;
                }
            }
        });

        // Generate message
        let message;
        if (hasStock) {
            if (locations.length === 1) {
                message = `En stock en ${locations[0]}`;
            } else if (locations.length === 2) {
                message = `En stock en ${locations[0]} y ${locations[1]}`;
            } else {
                const lastLocation = locations.pop();
                message = `En stock en ${locations.join(', ')} y ${lastLocation}`;
            }
        } else {
            message = "Sin stock en todas las sucursales";
        }

        return {
            hasStock,
            locations,
            message
        };
    } catch (error) {
        console.error('Error formatting stock status:', error);
        return { hasStock: false, locations: [], message: "Error al verificar stock" };
    }
};

// Get all locations with their status
export const getAllLocationStatus = (stockData) => {
    if (!stockData) return [];

    try {
        return Object.entries(stockData)
            .filter(([key]) => key !== 'stock' && key !== 'detail')
            .map(([locationCode, status]) => ({
                code: locationCode,
                name: LOCATION_NAMES[locationCode] || locationCode,
                status: status,
                hasStock: status === "En Stock"
            }));
    } catch (error) {
        console.error('Error getting location status:', error);
        return [];
    }
};
